import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 511,
	height: 398,
	viewBox: "0 0 511 398",
	fill: "transparent",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 15,
			y: 15,
			width: 368,
			height: 368,
			rx: 30,
			stroke: "white",
			strokeWidth: 30,
			fill: "transparent"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 198.5,
			cy: 198.5,
			r: 88.5,
			stroke: "white",
			strokeWidth: 30,
			fill: "transparent"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M451.698 80.8239C466.605 62.7122 496 73.2536 496 96.7116V310.211C496 334.007 465.897 344.346 451.276 325.572L388.276 244.677C384.857 240.287 383 234.881 383 229.316V173.252C383 167.455 385.014 161.839 388.698 157.364L451.698 80.8239Z",
			stroke: "white",
			strokeWidth: 30,
			fill: "transparent"
		})
	]
});
export default SvgVideo;
